import { type IconId } from '@stone-payments/jade'
import { resolveJadeIconId } from 'investments/common/utils'
import z from 'zod'

const JadeIconSchema = z.string().transform<IconId>(iconId => resolveJadeIconId(iconId) ?? 'piggy-bank')

const BucketCategorySchema = z.object({
  category: z.string().describe('Unique identifier for the bucket category'),
  categoryDescription: z.string().describe('Description of the bucket category'),
  jadeIcon: JadeIconSchema.describe('Icon identifier for the bucket category')
})

export type BucketCategory = z.infer<typeof BucketCategorySchema>

export const BucketCategorySettingsSchema = z.object({
  bucketCategorySettings: z.array(BucketCategorySchema).default([])
})

export const CreateBucketParamsSchema = z.object({
  accountId: z.string().uuid().describe('ID of the payment account'),
  name: z.string().describe('Name of the bucket'),
  category: z.string().describe('Category of the bucket')
})

export type CreateBucketParams = z.infer<typeof CreateBucketParamsSchema>

export const CreateBucketResponseSchema = z.object({
  bucketId: z.string().describe('ID of the created bucket')
})

export type CreateBucketResponse = z.infer<typeof CreateBucketResponseSchema>

export const CreateBucketFormSchema = z
  .object({
    bucketName: z.string().min(1, 'Bucket name is required').max(24, 'Bucket name must be at most 24 characters long'),
    bucketCategory: z.string().min(1, 'Bucket category is required')
  })
  .describe('Schema for creating a bucket form')
